import { Grid } from "@chakra-ui/react";
import EventBox from "../Components/EventBox";
import { getCurrentLibraryEvents } from "../apis/library.api";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { IEventResponseModel } from "../models/library.models";

// All event data array for featured events
var allEventData: IEventResponseModel[] = [];

export default function FeaturedEvents() {
  const [eventData, setEventData] = useState(allEventData);
  const [isLoading, setIsLoading] = useState(true);

  // Define size for tablets or smaller
  const isTabletOrSmaller = useMediaQuery({
    query: "(max-width: 800px)",
  });

  useEffect(() => {
    const runGetEvents = async () => {
      allEventData = await getCurrentLibraryEvents();

      // Sort the even data from most recent first
      allEventData.sort((a, b) => (a.date > b.date ? 1 : -1));

      // Get only the first 2 elements as we only want 2 to feature.
      allEventData = allEventData.slice(0, 2);

      setEventData(allEventData);
      setIsLoading(false);
    };

    // Run Events or stop loading
    if (allEventData.length === 0) {
      runGetEvents();
    } else {
      if (isLoading === true) {
        setIsLoading(false);
      }
    }

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {/* CONTENTS COMPONENT */}
      <Grid
        gap="2%"
        margin="2%"
        templateColumns={
          isTabletOrSmaller ? "repeat(1, 1fr)" : "repeat(6, 1fr)"
        }
      >
        {eventData.map((allEventData, index) => {
          return (
            <EventBox
              key={index}
              id={allEventData.id}
              title={allEventData.title}
              image={allEventData.image}
              description={allEventData.description}
              size={"large"}
              colSpan={3}
              address={allEventData.address}
              city={allEventData.city}
              date={allEventData.date}
              startTime={allEventData.startTime}
              endTime={allEventData.endTime}
              hyperlink={allEventData.hyperlink}
              bookingLink={allEventData.bookingLink}
              repeatType={allEventData.repeatType}
              productTypeName={allEventData.productTypeName}
            />
          );
        })}
      </Grid>
    </>
  );
}
